import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { useScreenInit } from '../../useScreenInit';
export function Otp() {
  useScreenInit();
  const navigate = useNavigate();
  const [otp, setOtp] = useState(['', '', '', '']);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const handleChange = (index: number, value: string) => {
    if (value.length > 1) value = value.slice(-1);
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    // Auto-advance
    if (value && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  const handleKeyDown = (index: number, e: React.KeyboardEvent) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/create-password');
  };
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-159">
      <header className="px-4 py-4 flex items-center" data-id="element-160">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-text-secondary hover:text-text-primary" data-id="element-161">
          <ChevronLeft className="w-6 h-6" data-id="element-162" />
        </button>
      </header>

      <main className="flex-1 px-6 py-4" data-id="element-163">
        <div className="mb-8" data-id="element-164">
          <h1 className="text-3xl font-heading font-bold text-text-primary mb-2" data-id="element-165">
            Verify Code
          </h1>
          <p className="text-text-secondary leading-relaxed" data-id="element-166">
            We've sent a 4-digit verification code to your phone number ending
            in **4567.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-8" data-id="element-167">
          <div className="flex justify-between gap-4 max-w-[300px] mx-auto" data-id="element-168">
            {otp.map((digit, index) => <input key={index} ref={el => inputRefs.current[index] = el} type="number" value={digit} onChange={e => handleChange(index, e.target.value)} onKeyDown={e => handleKeyDown(index, e)} className="w-16 h-16 text-center text-2xl font-bold bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary focus:border-transparent transition-all outline-none text-text-primary" maxLength={1} required data-id="element-169" />)}
          </div>

          <div className="text-center" data-id="element-170">
            <p className="text-sm text-text-secondary" data-id="element-171">
              Didn't receive the code?{' '}
              <button type="button" className="font-semibold text-brand-primary hover:underline" data-id="element-172">
                Resend Code
              </button>
            </p>
          </div>

          <Button type="submit" fullWidth size="lg" disabled={otp.some(d => !d)} data-id="element-173">
            Verify & Continue
          </Button>
        </form>
      </main>
    </div>;
}